import { config } from "@/config";
export const UserService = {
    async getUsuarios(search = "", page = 1, pageSize = 10) {
        const token = localStorage.getItem("accessToken");
        const params = new URLSearchParams({
            search,
            page: page.toString(),
            pageSize: pageSize.toString(),
        });
        const response = await fetch(`${config.API_URL}/api/Usuario?${params.toString()}`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
        if (!response.ok)
            throw new Error("Error al obtener usuarios");
        return await response.json();
    },
    async createUsuario(data) {
        const token = localStorage.getItem("accessToken");
        const response = await fetch(`${config.API_URL}/api/Usuario`, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        });
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.mensaje || "Error al crear el usuario");
        }
        return await response.json();
    },
    async toggleStatus(id) {
        const token = localStorage.getItem("accessToken");
        const response = await fetch(`${config.API_URL}/api/Usuario/${id}/toggle-status`, {
            method: "PATCH",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
        if (!response.ok)
            throw new Error("Error al cambiar el estado del usuario");
        return await response.json();
    },
    async deleteUsuario(id) {
        const token = localStorage.getItem("accessToken");
        const response = await fetch(`${config.API_URL}/api/Usuario/${id}`, {
            method: "DELETE",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
        if (!response.ok)
            throw new Error("Error al eliminar el usuario");
        return await response.json();
    },
    async updateUsuario(id, data) {
        const token = localStorage.getItem("accessToken");
        const response = await fetch(`${config.API_URL}/api/Usuario/${id}`, {
            method: "PUT",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        });
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.errores || "Error al actualizar el usuario");
        }
        return await response.json();
    },
    async getTiposUsuario() {
        const token = localStorage.getItem("accessToken");
        const response = await fetch(`${config.API_URL}/api/TipoUsuario`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
        if (!response.ok)
            throw new Error("Error al obtener tipos de usuario");
        return await response.json();
    },
    async getRoles() {
        const token = localStorage.getItem("accessToken");
        const response = await fetch(`${config.API_URL}/api/Permission/roles`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
        if (!response.ok)
            throw new Error("Error al obtener roles");
        return await response.json();
    },
};
